<template>
  <div v-if="student === undefined || student === null"></div>
  <v-dialog v-else v-model="value" persistent max-width="500px" scrollable>
    <v-card>
      <v-card-title class="modal_title">
        <span class="modal_title-title"
          >Selecciona el nuevo estatus de asistencia de</span
        >
        <p class="student">
          {{ `${student.firstName} ${student.lastName} con Matrícula:` }}
          <span class="student">{{ student.personId }}</span>
        </p>
      </v-card-title>
      <v-card-text class="custom_box">
        <v-card class="custom_box-content">
          <v-checkbox
            v-model="selectedStatus"
            color="primary"
            value="ON_TIME"
            label="Puntual"
          >
          </v-checkbox>
          <v-checkbox
            v-model="selectedStatus"
            color="primary"
            value="LATE"
            label="Retardo"
          >
          </v-checkbox>
          <v-checkbox
            v-model="selectedStatus"
            color="primary"
            value="ABSENCE"
            label="Falta"
          >
          </v-checkbox>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-btn primary flat @click="close" class="modal_button">Cancelar</v-btn>
        <v-btn color="primary" @click="submit" class="modal_button"
          >Actualizar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Student } from '../utils.js'

export default {
  props: {
    value: Boolean,
    student: Student,
  },
  data: () => ({
    selectedStatus: '',
  }),
  methods: {
    submit() {
      this.$emit('updateAttendance', this.selectedStatus)
      this.closeModal()
    },
    close() {
      this.$emit('updateAttendance', null)
      this.closeModal()
    },
    closeModal() {
      this.student = null
      this.selectedStatus = ''
      this.$emit('input', !this.value)
    },
  },
  watch: {
    value() {
      this.selectedStatus = this.student.attendanceType
    },
  },
}
</script>

<style scoped>
/* override css */
::v-deep .v-btn__content {
  text-transform: initial !important;
}

.modal_title {
  display: flex;
  flex-direction: column;
  font-weight: bold;
  padding-top: 20px;
  padding-bottom: 0px;
}

.modal_title-title {
  text-align: center;
  font-size: 20px;
  font-weight: 400;
}

.modal_button {
  margin: 0;
  width: 50%;
  border-radius: 8px;
  border: 1px solid #cccc;
  color: #272727;
  text-transform: capitalize;
}

.modal_button:last-of-type {
  width: calc(50% - 10px);
  margin-left: 10px;
  font-size: 14px;
  font-weight: 500;
}
.custom_box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.custom_box-content {
  padding: 0 70px;
}
.student {
  font-size: 16px;
}
</style>
